import React, { useRef, useState, useEffect } from "react";
import { successMsg } from "../SuccessHandler";
import ErrorCodes from "../../constants/ErrorCodes";
import { useUpdateFunctions } from "../../functions";
import { TRACK_TYPES } from "../../constants/SiteConfig";

const SystemPreferencesModal = ({
  data,
  systemPreferences,
  setSystemPreferences,
  setSessionNoLongerExists,
}) => {
  const closeButtonRef = useRef();
  const { updateSystemPreferencesRacing } = useUpdateFunctions();
  const [trackTypesDraft, setTrackTypesDraft] = useState(
    systemPreferences.TrackTypesEnabled,
  );

  useEffect(() => {
    setTrackTypesDraft(systemPreferences.TrackTypesEnabled);
  }, [systemPreferences.TrackTypesEnabled]);

  const intervalChangeHandler = (event) => {
    let value = parseInt(event.target.value, 10);
    if (isNaN(value)) value = 0;
    if (value < 0) value = 0;
    if (value > 255) value = 255;

    setSystemPreferences((prev) => ({
      ...prev,
      IntervalPastPost: value,
    }));
  };

  const updateSystemPreferences = async () => {
    const res = await updateSystemPreferencesRacing(
      {
        IntervalPastPost: systemPreferences.IntervalPastPost,
        PickRulesEnabled: systemPreferences.PickRulesEnabled,
        TrackTypesEnabled: trackTypesDraft,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setSystemPreferences({
        IntervalPastPost: systemPreferences.IntervalPastPost,
        PickRulesEnabled: systemPreferences.PickRulesEnabled,
        TrackTypesEnabled: trackTypesDraft,
      });

      successMsg("System Preferences Updated");

      if (res.Result === 0) {
        closeButtonRef.current.click();
      }
    }
  };

  const handleCheckboxEnabledChange = (e) => {
    const checked = e.target.checked;
    setSystemPreferences((prev) => ({
      ...prev,
      PickRulesEnabled: checked,
    }));
  };

  const handleCheckboxTrackTypeChange = (e) => {
    const { name, checked } = e.target;
    const value = TRACK_TYPES[name];

    setTrackTypesDraft((prev) => (checked ? prev | value : prev & ~value));
  };

  const closeModal = () => {
    setTrackTypesDraft(systemPreferences.TrackTypesEnabled);
  };

  return (
    <div>
      <div
        className="modal fade"
        id="systemPreferencesModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-xs" style={{ margin: "4rem auto" }}>
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5 className="modal-title" id="systemPreferencesModal">
                System Preferences
              </h5>
              <span
                data-dismiss="modal"
                ref={closeButtonRef}
                style={{ cursor: "inherit" }}
              ></span>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => closeModal()}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <fieldset
                    className="scheduler-border"
                    style={{ width: "100%" }}
                  >
                    <legend className="scheduler-border lead">
                      Time frame in seconds to grade a bet as past post
                    </legend>
                    <div className="form-inline mt-2">
                      <label className="lead mr-2" style={{ fontSize: "18px" }}>
                        Interval Past Post:
                      </label>
                      <input
                        name="IntervalPastPost"
                        id="IntervalPastPost"
                        className="form-control"
                        type="number"
                        min="0"
                        max={255}
                        style={{ width: "75px" }}
                        value={systemPreferences.IntervalPastPost}
                        onChange={intervalChangeHandler}
                      />
                    </div>
                  </fieldset>
                  <fieldset
                    className="scheduler-border"
                    style={{ width: "100%" }}
                  >
                    <legend className="scheduler-border lead">
                      Apply (enabled/disabled) Picks Rules
                    </legend>
                    <div className="form-inline mt-2">
                      <label className="mr-2 lead mt-1"> Pick Rules</label>
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input mt-1"
                          id="switchPickRulesEvent"
                          checked={systemPreferences.PickRulesEnabled}
                          onChange={handleCheckboxEnabledChange}
                        />
                        <label
                          className="custom-control-label lead mt-1"
                          htmlFor="switchPickRulesEvent"
                        />
                      </div>
                    </div>
                  </fieldset>
                  <fieldset
                    className="scheduler-border"
                    style={{ width: "100%" }}
                  >
                    <legend className="scheduler-border lead">
                      Track Types display
                    </legend>

                    {Object.entries(TRACK_TYPES).map(([key, value]) => (
                      <div className="row mt-2" key={key}>
                        <div className="col-sm-12">
                          <div className="form-inline">
                            <label className="mr-2 lead mt-1">{key}</label>
                            <div className="custom-control custom-switch">
                              <input
                                type="checkbox"
                                className="custom-control-input mt-1"
                                id={`switch${key}`}
                                name={key}
                                checked={(trackTypesDraft & value) !== 0}
                                onChange={handleCheckboxTrackTypeChange}
                              />
                              <label
                                className="custom-control-label lead mt-1"
                                htmlFor={`switch${key}`}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </fieldset>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={updateSystemPreferences}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeModal()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemPreferencesModal;
